import { Footer } from './components/Footer';

function Blog() {
  return (
    <div className='Blog'>
        <div className='blog-content'>
            Blog goes here
        </div>
      <Footer />
    </div>
  );
}

export default Blog;
